import App from "./comps/App.svelte";
const app = new App({
    target: document.body,
    props: {}
});
export default app;
